import type { McpScope, McpToolName } from '@amitable/shared/mcp-contract'

export type McpManagementStatus = 'unavailable' | 'disabled' | 'enabled'

export type McpUsageDailyPointMock = {
  date: string
  calls: number
  successes: number
  denials: number
  errors: number
  recordsRead: number
}

export type McpUsageByToolMock = {
  toolName: McpToolName
  calls: number
  recordsRead: number
}

export type McpUsageEventMock = {
  id: string
  createdAt: string
  toolName: McpToolName
  clientName: string
  status: 'DENIED' | 'ERROR'
  message: string
}

export type McpUsageMock = {
  calls: number
  successes: number
  denials: number
  errors: number
  fieldsCreated: number
  recordsRead: number
  recordsWritten: number
  daily: Array<McpUsageDailyPointMock>
  byTool: Array<McpUsageByToolMock>
  recentEvents: Array<McpUsageEventMock>
}

export type McpManagementMockState = {
  status: McpManagementStatus
  usage: McpUsageMock
  canConfigure: boolean
}

export const mcpScopeLabels: Record<McpScope, string> = {
  ANALYSIS_READ: 'Analysis read',
  AUTOMATION_READ: 'Automation read',
  AUTOMATION_WRITE: 'Automation write',
  DOCUMENT_LISTS_READ: 'Document Lists read',
  DOCUMENT_LISTS_WRITE: 'Document Lists write',
  METADATA_READ: 'Metadata read',
  METADATA_WRITE: 'Metadata write',
  RECORDS_READ: 'Records read',
  RECORDS_WRITE: 'Records write',
}

export const mcpScopeDescriptions: Record<McpScope, string> = {
  ANALYSIS_READ: 'Allow bounded summaries, samples, and aggregate reads.',
  AUTOMATION_READ:
    'Allow reading automations, recipes and execution history, and previewing automations without running them.',
  AUTOMATION_WRITE:
    'Allow creating, editing, activating, archiving, testing, running and cancelling automations in the workspace.',
  DOCUMENT_LISTS_READ: 'Allow reading Document Lists and their items.',
  DOCUMENT_LISTS_WRITE:
    'Allow adding, updating, moving, removing, and finalizing Document List items.',
  METADATA_READ: 'Allow workspace and DocumentCollection metadata reads.',
  METADATA_WRITE:
    'Allow creating, editing, and deleting collections and fields in the workspace.',
  RECORDS_READ: 'Allow bounded DocumentRecord reads and lookups.',
  RECORDS_WRITE:
    'Allow creating, updating, and deleting records in the workspace.',
}

export const selectableMcpScopes: Array<McpScope> = [
  'METADATA_READ',
  'METADATA_WRITE',
  'AUTOMATION_READ',
  'AUTOMATION_WRITE',
  'DOCUMENT_LISTS_READ',
  'DOCUMENT_LISTS_WRITE',
  'RECORDS_READ',
  'RECORDS_WRITE',
  'ANALYSIS_READ',
]
